<template>
	<div>
		<hy-slider></hy-slider>
	</div>
</template>
<script>
	import hySlider from './../components/hy-slider'

	export default {
		data() {
			return {};
		},
		mounted() {

		},
		methods: {

		},
		watch: {},
		components: {
			hySlider
		},
		computed: {},
		updated() {},
		created() {}
	};
</script>
<style>

</style>
